import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import type {WixMediaResource} from "@wix/devzai-common-wix";
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export namespace DoppeActionTypeDevMediaView {
    export interface ActionSettings {
        mediaResource: WixMediaResource | null;
    }
}

export const doppeActionTypeDevMediaView = doppeActionTypeDefineMetadata<DoppeActionTypeDevMediaView.ActionSettings>({
    id: 'io.bymo.action/dev-media-view',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        mediaResource: null
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true
});